var i;(function(d){d.Loading="loading",d.NoConnection="no_connection",d.Connected="connected"})(i||(i={}));export{i as EthosConnectStatus};
